import ConsignmentIcon from "@components/icons/menu/ConsignmentIcon";
import CustomerIcon from "@components/icons/menu/CustomerIcon";
import DirectSalesOrderIcon from "@components/icons/menu/DirectSalesOrderIcon";
import DirectSalesReturnIcon from "@components/icons/menu/DirectSalesReturnIcon";
import DistributionRegionIcon from "@components/icons/menu/DistributionRegionIcon";
import ExpenseManagementIcon from "@components/icons/menu/ExpenseManagementIcon";
import PrimarySalesOrderIcon from "@components/icons/menu/PrimarySalesOrderIcon";
import PrimarySalesReturnIcon from "@components/icons/menu/PrimarySalesReturnIcon";
import ProductIcon from "@components/icons/menu/ProductIcon";
import SecondarySalesOrderIcon from "@components/icons/menu/SecondarySalesOrderIcon";
import SecondarySalesReturnIcon from "@components/icons/menu/SecondarySalesReturnIcon";
import SupplierIcon from "@components/icons/menu/SupplierIcon";
import TripIcon from "@components/icons/menu/TripIcon";
import UnitIcon from "@components/icons/menu/UnitIcon";
import UserManagementIcon from "@components/icons/menu/UserManagementIcon";
import WarehouseAndInventoryIcon from "@components/icons/menu/WarehouseAndInventoryIcon";

const mainModules = [
  {
    id: 1,
    name: "User Management",
    path: "/user-management",
    subModules: [
      {
        id: 11,
        name: "Office User",
        path: "/office-user",
      },
      {
        id: 12,
        name: "Customer User",
        path: "/customer-user/customer",
      },
      {
        id: 13,
        name: "User Role Assign",
        path: "/user-role-assign",
      },
    ],
    renderIcon: (isRouted: boolean) => {
      return <UserManagementIcon isRouted={isRouted} />;
    },
  },
  {
    id: 2,
    name: "Product",
    path: "/product",
    subModules: [
      {
        id: 21,
        name: "Product Information",
        path: "/product-information",
      },
      {
        id: 22,
        name: "Product Category",
        path: "/product-category",
      },
      {
        id: 23,
        name: "Product Group",
        path: "/product-tag",
      },
      {
        id: 24,
        name: "Brand",
        path: "/brand",
      },
    ],
    renderIcon: (isRouted: boolean) => {
      return <ProductIcon isRouted={isRouted} />;
    },
  },
  {
    id: 3,
    name: "Unit",
    path: "/unit",
    subModules: [
      {
        id: 31,
        name: "Unit of Conversion",
        path: "/unit-of-conversion",
      },
      {
        id: 32,
        name: "Unit of Measurement",
        path: "/unit-of-measurement",
      },
    ],
    renderIcon: (isRouted: boolean) => {
      return <UnitIcon isRouted={isRouted} />;
    },
  },
  {
    id: 4,
    name: "Customer",
    path: "/customer",
    subModules: [
      {
        id: 41,
        name: "Customer Channel",
        path: "/customer-channel",
      },
      {
        id: 42,
        name: "Customer",
        path: "/customer",
      },
      {
        id: 43,
        name: "Business Unit",
        path: "/business-unit",
      },
    ],
    renderIcon: (isRouted: boolean) => {
      return <CustomerIcon isRouted={isRouted} />;
    },
  },
  {
    id: 5,
    name: "Distribution Region",
    path: "/distribution-region",
    subModules: [
      {
        id: 51,
        name: "Distribution Region Management",
        path: "/distribution-region-management",
      },
      {
        id: 52,
        name: "Way Management",
        path: "/way-management",
      },
      {
        id: 53,
        name: "Way User Assign",
        path: "/way-user-assign",
      },
    ],
    renderIcon: (isRouted: boolean) => {
      return <DistributionRegionIcon isRouted={isRouted} />;
    },
  },
  {
    id: 6,
    name: "Stock & Inventory",
    path: "/stock-and-inventory",
    subModules: [
      {
        id: 61,
        name: "Allocation Account",
        path: "/allocation-account",
      },
      {
        id: 62,
        name: "Allocation Account User Assign",
        path: "/allocation-account-user-assign",
      },
      {
        id: 63,
        name: "Stock Import",
        path: "/stock-import",
      },
      {
        id: 64,
        name: "Stock Transfer",
        path: "/stock-transfer",
      },
      {
        id: 65,
        name: "Stock Balance",
        path: "/stock-balance",
      },
      {
        id: 66,
        name: "Stock Adjustment",
        path: "/stock-adjustment",
      },
    ],
    renderIcon: (isRouted: boolean) => {
      return <WarehouseAndInventoryIcon isRouted={isRouted} />;
    },
  },
  {
    id: 7,
    name: "Sales Order",
    path: "/sale-order",
    subModules: [
      {
        id: 71,
        name: "Sales Order",
        path: "/sale-order",
      },
      {
        id: 72,
        name: "Order Approval",
        path: "/order-approval",
      },
      {
        id: 73,
        name: "Invoice",
        path: "/invoice",
      },
      {
        id: 74,
        name: "Payment Receive",
        path: "/payment-receive",
      },
    ],
    renderIcon: (isRouted: boolean) => {
      return <PrimarySalesOrderIcon isRouted={isRouted} />;
    },
  },
  {
    id: 8,
    name: "Secondary Sales Order",
    path: "/secondary-sale-order",
    subModules: [
      {
        id: 81,
        name: "Sales Order",
        path: "/sale-order",
      },
      {
        id: 82,
        name: "Order Approval",
        path: "/order-approval",
      },
      {
        id: 83,
        name: "Invoice",
        path: "/invoice",
      },
      {
        id: 84,
        name: "Payment Receive",
        path: "/payment-receive",
      },
    ],
    renderIcon: (isRouted: boolean) => {
      return <SecondarySalesOrderIcon isRouted={isRouted} />;
    },
  },
  // {
  //   id: 9,
  //   name: "Direct Sales Order",
  //   path: "/direct-sale-order",
  //   subModules: [
  //     {
  //       id: 91,
  //       name: "Sales Order",
  //       path: "/sale-order",
  //     },
  //     {
  //       id: 92,
  //       name: "Order Approval",
  //       path: "/order-approval",
  //     },
  //     {
  //       id: 92,
  //       name: "Invoice",
  //       path: "/invoice",
  //     },
  //     {
  //       id: 94,
  //       name: "Payment Receive",
  //       path: "/payment-receive",
  //     },
  //   ],
  //   renderIcon: (isRouted: boolean) => {
  //     return <DirectSalesOrderIcon isRouted={isRouted} />;
  //   },
  // },
  {
    id: 10,
    name: "Supplier Management",
    path: "/supplier-management",
    subModules: [
      {
        id: 101,
        name: "Supplier",
        path: "/supplier",
      },
    ],
    renderIcon: (isRouted: boolean) => {
      return <SupplierIcon isRouted={isRouted} />;
    },
  },
  {
    id: 11,
    name: "Sales Target",
    path: "/sale-target",
    subModules: [
      {
        id: 111,
        name: "All Target",
        path: "/all-target",
      },
      {
        id: 112,
        name: "Product Target",
        path: "/product-target",
      },
    ],
    renderIcon: (isRouted: boolean) => {
      return <SupplierIcon isRouted={isRouted} />;
    },
  },
  // {
  //     id: 12,
  //     name: 'Sales Return',
  //     path: '/primary-sales-return',
  //     subModules: [
  //         {
  //             id: 121,
  //             name: 'Sales Return',
  //             path: '/sales-return',
  //         },
  //         {
  //             id: 122,
  //             name: 'Make Payment',
  //             path: '/make-payment',
  //         },
  //     ],
  //     renderIcon: (isRouted: boolean) => {
  //         return <PrimarySalesReturnIcon isRouted={isRouted} />;
  //     },
  // },
  {
    id: 13,
    name: "Sales Return",
    path: "/sales-return",
    subModules: [
      {
        id: 131,
        name: "Sales Return",
        path: "/sales-return",
      },
      {
        id: 132,
        name: "Make Payment",
        path: "/make-payment",
      },
    ],
    renderIcon: (isRouted: boolean) => {
      return <SecondarySalesReturnIcon isRouted={isRouted} />;
    },
  },
  // {
  //     id: 14,
  //     name: 'Purchase',
  //     path: '/purchase',
  //     subModules: [
  //         {
  //             id: 123,
  //             name: 'Purchase Order',
  //             path: '/purchase-order',
  //         },
  //         {
  //             id: 141,
  //             name: 'Bill',
  //             path: '/bill',
  //         },
  //         {
  //             id: 142,
  //             name: 'Payment Made',
  //             path: '/payment-made',
  //         },
  //     ],
  //     renderIcon: (isRouted: boolean) => {
  //         return <PurchaseIcon isRouted={isRouted} />;
  //     },
  // },
  {
    id: 15,
    name: "Expense Management",
    path: "/expense-management",
    subModules: [
      {
        id: 151,
        name: "Expense",
        path: "/expense",
      },
    ],
    renderIcon: (isRouted: boolean) => {
      return <ExpenseManagementIcon isRouted={isRouted} />;
    },
  },
  {
    id: 16,
    name: "Trip",
    path: "/trip",
    subModules: [
      {
        id: 161,
        name: "Vehicle Management",
        path: "/vehicle-management",
      },
      {
        id: 162,
        name: "Trip Proposal",
        path: "/trip-proposal",
      },
      {
        id: 163,
        name: "Trip Proposal Approval",
        path: "/trip-proposal-approval",
      },
      {
        id: 164,
        name: "Trip Sales Request",
        path: "/trip-sales-request",
      },
      // {
      //   id: 163,
      //   name: "Trip User Assign",
      //   path: "/trip-user-assign",
      // },
      {
        id: 165,
        name: "Sales Order",
        path: "/sales-order",
      },
      {
        id: 166,
        name: "Invoice",
        path: "/invoice",
      },
      {
        id: 167,
        name: "Payment Receive",
        path: "/payment-receive",
      },
    ],
    renderIcon: (isRouted: boolean) => {
      return <TripIcon isRouted={isRouted} />;
    },
  },
  {
    id: 17,
    name: "Consignment",
    path: "/consignment",
    subModules: [
      {
        id: 171,
        name: "Consignment Contract",
        path: "/consignment-contract",
      },
      {
        id: 172,
        name: "Consignment",
        path: "/consignment",
      },
      {
        id: 173,
        name: "Consignment Approval",
        path: "/consignment-approval",
      },
      {
        id: 174,
        name: "Invoice",
        path: "/invoice",
      },
      {
        id: 175,
        name: "Payment Receive",
        path: "/payment-receive",
      },
    ],
    renderIcon: (isRouted: boolean) => {
      return <ConsignmentIcon isRouted={isRouted} />;
    },
  },
  {
    id: 18,
    name: "Consignment Return",
    path: "/consignment-return",
    subModules: [
      {
        id: 181,
        name: "Consignment Return",
        path: "/",
      },
    ],
    renderIcon: (isRouted: boolean) => {
      return <ConsignmentIcon isRouted={isRouted} />;
    },
  },
  {
    id: 18,
    name: "Trip Sales Return",
    path: "/trip-sales-return",
    subModules: [
      {
        id: 181,
        name: "Trip Sales Return",
        path: "/sales-return",
      },
      {
        id: 182,
        name: "Make Payment",
        path: "/make-payment",
      },
    ],
    renderIcon: (isRouted: boolean) => {
      return <PrimarySalesReturnIcon isRouted={isRouted} />;
    },
  },
  {
    id: 19,
    name: "Consignment Return",
    path: "/consignment-return",
    subModules: [
      {
        id: 191,
        name: "Consignment Return",
        path: "/sales-return",
      },
      {
        id: 192,
        name: "Make Payment",
        path: "/make-payment",
      },
    ],
    renderIcon: (isRouted: boolean) => {
      return <PrimarySalesReturnIcon isRouted={isRouted} />;
    },
  },
  {
    id: 20,
    name: "Direct Sales Return",
    path: "/direct-sales-return",
    subModules: [
      {
        id: 201,
        name: "Sales Return",
        path: "/sales-return",
      },
      {
        id: 202,
        name: "Make Payment",
        path: "/make-payment",
      },
    ],
    renderIcon: (isRouted: boolean) => {
      return <DirectSalesReturnIcon isRouted={isRouted} />;
    },
  },
  {
    id: 21,
    name: "Sales Report",
    path: "/reports",
    subModules: [
      {
        id: 211,
        name: "Sales By Product",
        path: "/sales-by-product",
      },
      {
        id: 212,
        name: "Sales By Product Category",
        path: "/sales-by-product-category",
      },
    ],
    renderIcon: (isRouted: boolean) => {
      return <DirectSalesReturnIcon isRouted={isRouted} />;
    },
  },
  {
    id: 16,
    name: "Goods Request",
    path: "/goods-request",
    subModules: [
      {
        id: 150,
        name: "Goods Request Note",
        path: "/goods-request-note",
      },
      {
        id: 151,
        name: "Goods Issue Note",
        path: "/goods-issue-note",
      },
      {
        id: 151,
        name: "Delivery Note",
        path: "/goods-delivery-note",
      },
    ],
    renderIcon: (isRouted: boolean) => {
      return (
        <svg
          width="25"
          height="24"
          viewBox="0 0 25 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.88701 8.96542C7.25727 8.96542 7.55624 8.66415 7.55624 8.29619C7.55624 7.92592 7.25497 7.62695 6.88701 7.62695C6.51904 7.62695 6.21777 7.92822 6.21777 8.29619C6.21777 8.66415 6.51674 8.96542 6.88701 8.96542ZM6.88701 8.1168C6.9859 8.1168 7.06639 8.1973 7.06639 8.29619C7.06639 8.39508 6.9859 8.47557 6.88701 8.47557C6.78812 8.47557 6.70762 8.39508 6.70762 8.29619C6.70762 8.1973 6.78812 8.1168 6.88701 8.1168Z"
            fill={isRouted ? "#ffffff" : "#6b7280"}
            stroke="#737791"
            stroke-width="0.2"
          />
          <path
            d="M13.2435 8.96542C13.6137 8.96542 13.9127 8.66415 13.9127 8.29619C13.9127 7.92592 13.6114 7.62695 13.2435 7.62695C12.8732 7.62695 12.5742 7.92822 12.5742 8.29619C12.5742 8.66415 12.8755 8.96542 13.2435 8.96542ZM13.2435 8.1168C13.3423 8.1168 13.4228 8.1973 13.4228 8.29619C13.4228 8.39508 13.3423 8.47557 13.2435 8.47557C13.1446 8.47557 13.0641 8.39508 13.0641 8.29619C13.0641 8.1973 13.1446 8.1168 13.2435 8.1168Z"
            fill={isRouted ? "#ffffff" : "#6b7280"}
            stroke="#737791"
            stroke-width="0.2"
          />
          <path
            d="M16.7827 14.8299L16.2951 7.29812C16.256 6.70478 15.7616 6.24253 15.1705 6.24253C15.1682 6.24253 15.1659 6.24253 15.1636 6.24253L13.4779 6.24942V3.93816C13.4779 2.01095 11.9072 0.5 9.90178 0.5H9.88568C7.86188 0.5 6.21524 2.04315 6.21524 3.93816V6.28852L4.97107 6.29542C4.6583 6.29772 4.37313 6.42881 4.16845 6.64039C4.15695 6.65188 4.14315 6.66338 4.13395 6.67718C3.97067 6.85886 3.86718 7.09344 3.85108 7.35331L3.00246 20.3907C2.98177 20.7012 3.09216 21.0093 3.30603 21.237C3.51991 21.4647 3.82118 21.5958 4.13165 21.5958H8.05276C8.08956 21.6073 8.12865 21.6119 8.16775 21.6119C8.20684 21.6119 8.24594 21.6073 8.28504 21.5958H13.0318C13.8137 22.7434 15.1292 23.5 16.6194 23.5C19.0112 23.5 20.9545 21.5544 20.9545 19.1649C20.9568 16.8261 19.0986 14.915 16.7827 14.8299ZM7.06616 3.93816C7.06616 2.51 8.33103 1.34862 9.88568 1.34862H9.90178C11.4288 1.34862 12.627 2.487 12.627 3.93816V6.25402L7.06616 6.28392V3.93816ZM4.97797 7.14404L13.2548 7.09804L15.1659 7.09114H15.1682C15.3154 7.09114 15.4373 7.20613 15.4465 7.35331L15.9341 14.8805C15.2372 14.9909 14.5956 15.2691 14.0506 15.6716C12.1509 15.4071 10.5273 14.9357 8.95657 14.478C8.18845 14.2549 7.45482 14.041 6.6982 13.8525L4.95267 7.14634C4.95957 7.14634 4.96877 7.14404 4.97797 7.14404ZM12.4591 17.9507C11.4012 17.7161 10.41 17.4332 9.45102 17.1572C8.75419 16.9572 8.09186 16.7686 7.41342 16.5984L6.94427 14.7954C7.53071 14.9518 8.11485 15.1196 8.71969 15.2967C10.1364 15.7107 11.5967 16.1338 13.2732 16.4144C12.903 16.8606 12.6247 17.3803 12.4591 17.9507ZM3.92467 20.6552C3.89248 20.623 3.84188 20.5517 3.84878 20.4459L4.58471 9.11724L7.6135 20.7449H4.13165C4.02586 20.7449 3.95687 20.6897 3.92467 20.6552ZM8.49202 20.7449L7.6572 17.5367C8.17005 17.6724 8.6829 17.8196 9.21644 17.9714C10.1984 18.2542 11.2103 18.544 12.3027 18.7832C12.2912 18.9074 12.2843 19.0338 12.2843 19.1603C12.2843 19.7192 12.3924 20.2527 12.5856 20.7426H8.49202V20.7449ZM16.6217 22.6491C14.6991 22.6491 13.1353 21.0852 13.1353 19.1626C13.1353 17.24 14.6991 15.6762 16.6217 15.6762C18.5443 15.6762 20.1082 17.24 20.1082 19.1626C20.1082 21.0852 18.5443 22.6491 16.6217 22.6491Z"
            fill={isRouted ? "#ffffff" : "#6b7280"}
            stroke="#737791"
            stroke-width="0.2"
          />
          <path
            d="M16.6571 16.6992V17.0798C16.1229 17.1179 15.6929 17.5535 15.6929 18.082C15.6929 18.5665 16.0523 18.9798 16.5426 19.0664L16.6571 19.0898V20.4492H16.5366C16.4511 20.4494 16.3664 20.4331 16.2873 20.4014C16.2083 20.3697 16.1364 20.3231 16.076 20.2643C16.0155 20.2055 15.9675 20.1356 15.9349 20.0588C15.9023 19.9819 15.8855 19.8996 15.8857 19.8164V19.5117H15.5V19.8164C15.5 20.3695 15.9679 20.8242 16.5366 20.8242H16.6571V21.1992H17.0429V20.8242H17.1634C17.7319 20.8242 18.2 20.3693 18.2 19.8164C18.2 19.3319 17.8407 18.9187 17.3503 18.832L17.0429 18.7733V17.4552C17.2019 17.4719 17.3489 17.5451 17.4557 17.6608C17.5625 17.7765 17.6215 17.9266 17.6214 18.082V18.3867H18.0071V18.082C18.0071 17.5533 17.5771 17.1179 17.0429 17.08V16.6992H16.6571ZM16.6571 17.4548V18.7032L16.6089 18.6972C16.46 18.6722 16.325 18.5967 16.2279 18.4841C16.1308 18.3715 16.0779 18.2291 16.0786 18.0822C16.0784 17.9267 16.1374 17.7766 16.2442 17.6608C16.351 17.545 16.4981 17.4715 16.6571 17.4548ZM17.0429 19.1602L17.2839 19.2014C17.4329 19.2264 17.5679 19.3019 17.665 19.4145C17.7621 19.5271 17.815 19.6695 17.8143 19.8164C17.8144 19.8995 17.7977 19.9819 17.7651 20.0587C17.7324 20.1356 17.6845 20.2054 17.624 20.2642C17.5635 20.323 17.4917 20.3696 17.4127 20.4014C17.3336 20.4331 17.2489 20.4494 17.1634 20.4492H17.0429V19.1602Z"
            fill={isRouted ? "#ffffff" : "#6b7280"}
            stroke="#737791"
            stroke-width="0.2"
          />
        </svg>
      );
    },
  },
  {
    id: 22,
    name: "Goods Return",
    path: "/good-return",
    subModules: [
      {
        id: 221,
        name: "Goods Return Note",
        path: "/good-return-note",
      },
      {
        id: 221,
        name: "Goods Receive Note",
        path: "/good-receive-note",
      },
    ],
    renderIcon: (isRouted: boolean) => {
      return <DirectSalesReturnIcon isRouted={isRouted} />;
    },
  },
  {
    id: 23,
    name: "Marketing Promotion",
    path: "/marketing-promotion",
    subModules: [
      {
        id: 222,
        name: "Marketing Plan",
        path: "/plans",
      },
      {
        id: 223,
        name: "Marketing Good Requisition",
        path: "/good-requisition",
      },
      {
        id: 224,
        name: "Invoices",
        path: "/invoices",
      },
      {
        id: 225,
        name: "Payment Received",
        path: "/payment-received",
      },
    ],
    renderIcon: (isRouted: boolean) => {
      return <UserManagementIcon isRouted={isRouted} />;
    },
  },
  {
    id: 26,
    name: "Marketing Promotion Return",
    path: "/marketing-promotion-return",
    subModules: [
      {
        id: 242,
        name: "Marketing Promotion Return",
        path: "/returns",
      },
      {
        id: 243,
        name: "Make Payment",
        path: "/make-payment",
      },
    ],
    renderIcon: (isRouted: boolean) => {
      return <UserManagementIcon isRouted={isRouted} />;
    },
  },
  {
    id: 24,
    name: "Promotion",
    path: "/sale-promotion",
    subModules: [
      {
        id: 226,
        name: "Sale Promotion Plan",
        path: "/plans",
      },
    ],
    renderIcon: (isRouted: boolean) => {
      return <UserManagementIcon isRouted={isRouted} />;
    },
  },
  {
    id: 25,
    name: "Bank Information",
    path: "/bank-information",
    subModules: [
      {
        id: 226,
        name: "Bank Information",
        path: "/",
      },
    ],
    renderIcon: (isRouted: boolean) => {
      return <UserManagementIcon isRouted={isRouted} />;
    },
  },

  {
    id: 26,
    name: "Report",
    path: "/reports",
    subModules: [
      {
        id: 227,
        name: "Sales By Product",
        path: "/sales-by-product",
      },
      {
        id: 228,
        name: "Sales By Product Customer",
        path: "/sales-by-product-customer",
      },
      {
        id: 229,
        name: "Delivered Good Issue",
        path: "/delivered-good-issue",
      },
      {
        id: 230,
        name: "Pending Delivery Good Issue",
        path: "/pending-delivery-good-issue",
      },
      {
        id: 231,
        name: "Issued Item By Request Reason",
        path: "/issued-item-by-request-reason",
      },
      {
        id: 232,
        name: "Allocation Balance Report",
        path: "/allocation-balance-report",
      },
      {
        id: 233,
        name: "Stock Adjustment Report",
        path: "/stock-adjustment-report",
      },
      {
        id: 234,
        name: "Inventory Report",
        path: "/inventory-report",
      },
      {
        id: 235,
        name: "Delivery Orders By Item",
        path: "/delivery-orders-by-item-report",
      },
      {
        id: 236,
        name: "Delivery Orders By Customer",
        path: "/delivery-orders-by-customer-report",
      },
      {
        id: 237,
        name: "Customer Sales Analysis",
        path: "/customer-sales-analysis-report",
      },
    ],
    renderIcon: (isRouted: boolean) => {
      return <UserManagementIcon isRouted={isRouted} />;
    },
  },
  {
    id: 27,
    name: "CMS",
    path: "/cms",
    subModules: [
      {
        id: 300,
        name: "Slider Management",
        path: "/slider-management",
      },
    ],
    renderIcon: (isRouted: boolean) => {
      return <UserManagementIcon isRouted={isRouted} />;
    },
  },
];

export default mainModules;
